import React from 'react';
import { motion } from 'framer-motion';
import { UserIcon, ShieldCheckIcon, HeartIcon } from 'lucide-react';
export function DoctorIntro() {
  return <section className="w-full py-20 lg:py-24 bg-white relative overflow-hidden" data-id="element-41">
      <div className="absolute inset-0" data-id="element-42">
        <div className="absolute top-0 left-0 w-[600px] h-[600px] bg-brand-aqua/10 rounded-full blur-3xl" data-id="element-43" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl" data-id="element-44" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12 sm:mb-16" data-id="element-46">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-gold/10 rounded-full mb-4" data-id="element-47">
            <UserIcon className="w-4 h-4 text-brand-gold" data-id="element-48" />
            <span className="text-brand-gold font-semibold text-xs sm:text-sm uppercase tracking-wider" data-id="element-49">
              Licensed Physician
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-brand-navy mb-4 sm:mb-6 px-4" data-id="element-50">
            Meet Dr. Mark Joy, MD
          </h2>
        </motion.div>

        <div className="max-w-4xl mx-auto px-4" data-id="element-51">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-gradient-to-br from-white to-brand-aqua/5 rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 shadow-xl border border-brand-gold/10" data-id="element-52">
            <div className="prose prose-lg max-w-none" data-id="element-53">
              <p className="text-lg sm:text-xl text-gray-700 leading-relaxed mb-4 sm:mb-6" data-id="element-54">
                Dr. Mark Joy is a licensed medical doctor practicing in the
                state of New York.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-4 sm:mb-6" data-id="element-55">
                He provides professional medical evaluations and consultations
                by scheduled appointment only.
              </p>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed" data-id="element-56">
                All appointment requests are reviewed and coordinated by a
                medical coordinator prior to confirmation.
              </p>
            </div>

            <div className="mt-8 sm:mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-57">
              <div className="flex items-start gap-3" data-id="element-58">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-59">
                  <ShieldCheckIcon className="w-5 h-5 text-brand-gold" data-id="element-60" />
                </div>
                <div data-id="element-61">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-62">
                    Licensed MD
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-63">
                    State of New York
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-64">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-65">
                  <HeartIcon className="w-5 h-5 text-brand-gold" data-id="element-66" />
                </div>
                <div data-id="element-67">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-68">
                    Patient-Focused
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-69">
                    Individualized Care
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-70">
                <div className="flex-shrink-0 w-10 h-10 bg-brand-gold/10 rounded-full flex items-center justify-center" data-id="element-71">
                  <UserIcon className="w-5 h-5 text-brand-gold" data-id="element-72" />
                </div>
                <div data-id="element-73">
                  <p className="font-semibold text-brand-navy mb-1 text-sm sm:text-base" data-id="element-74">
                    Bilingual
                  </p>
                  <p className="text-xs sm:text-sm text-gray-600" data-id="element-75">
                    English & Spanish
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}